module.exports = __webpack_public_path__ + "static/media/rm5.898f795c.jpg";